module.exports = function() {
  return new Worker(__webpack_public_path__ + "83821843f5f32b9cae39.worker.js");
};